/**
 * Przeciągnięcie karty kontrahenta na tablicy Kanban = zwykły zapis rekordu, na tych samych
 * zasadach co formularz (`ContractorDetail`). Cała logika (pole grupowania, ostrzeżenie procedury
 * kontrolnej, blokada zadania przycisku SQL, komunikaty) żyje we wspólnym haku
 * `useRecordKanbanMove`; tu tylko konfiguracja kontrahentów: `PATCH /api/contractors/:id`, prawo
 * edycji kontrahentów, rdzenne pola z dedykowaną kolumną (firma, opiekun, przypisany, kategoria)
 * i komunikat odrzucenia wspólny z formularzem (`contractorSaveErrorMessage`).
 */

import { CONTRACTORS_EXCLUDE_SLUGS } from '@/lib/contractors/contractor-columns';
import { contractorSaveErrorMessage } from '@/lib/contractors/contractor-save-errors';
import type { SystemModuleFieldDef } from '@/lib/ext-list-columns';
import {
  type RecordKanbanMove,
  type RecordKanbanMoveConfig,
  useRecordKanbanMove,
} from '@/lib/records/useRecordKanbanMove';

/** Rdzenne pola kontrahenta z dedykowaną kolumną — wykluczone z kolumn katalogu, albo kategoria. */
function hasDedicatedColumn(slug: string): boolean {
  return CONTRACTORS_EXCLUDE_SLUGS.has(slug) || slug === 'category_id';
}

const CONTRACTOR_KANBAN_MOVE_CONFIG: RecordKanbanMoveConfig = {
  savePath: (id) => `/contractors/${id}`,
  editPermission: 'crm_core.contractors.edit',
  hasDedicatedColumn,
  saveErrorMessage: contractorSaveErrorMessage,
  fallbackToastKey: 'tenant.contractors.toast.updateError',
};

export type ContractorKanbanMove = RecordKanbanMove;

export function useContractorKanbanMove(opts: {
  fields: readonly SystemModuleFieldDef[];
  /** Po udanym zapisie (odświeżenie listy). */
  onSaved: () => void;
}): ContractorKanbanMove {
  return useRecordKanbanMove(CONTRACTOR_KANBAN_MOVE_CONFIG, opts);
}
